import { render } from "./Agenda.vue?vue&type=template&id=189b0ab4&ts=true"
import script from "./Agenda.vue?vue&type=script&lang=ts"
export * from "./Agenda.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__